module.exports = __webpack_public_path__ + "static/building_4x-fd941382a7226947e3d287baaffa905d.jpg";